// extracted by mini-css-extract-plugin
export var editButton = "_kb-0";